export default "__VITE_ASSET__CcqMHvSB__"